import React from 'react';
import { Link, useSubmit, useActionData, useNavigation } from 'react-router-dom';
import './action_window.scss';

class ActionWindow extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      actionTrigerred: false,
    };
  }

  hasFinished() {
    return !this.hasFailed() && !this.isLoading() && this.state.actionTrigerred;
  }

  isLoading() {
    return this.props.navigation.state === "submitting";
  }

  hasFailed() {
    return this.props.errorMessage.length > 0;
  }

  getIcon() {
    if(this.isLoading()) {
      return (
        <div key="action_window:loading_icon">
          <i className="fas fa-spinner action-window__loading-icon"></i>
        </div>
      );
    }
    else if(this.hasFailed()) {
      return (
        <div key="action_window:error_icon">
          <i className="fas fa-times action-window__error-icon"></i>
        </div>
      );
    }
    else if(this.props.useSuccessIcon) {
      return (
        <div key="action_window:success_icon">
          <i className="fas fa-circle-check action-window__success-icon"></i>
        </div>
      );
    }

    return (
      <div key="action_window:alert_icon">
        <i className="fas fa-exclamation-circle action-window__alert-icon"></i>
      </div>
    );
  }

  getTitle() {
    if (this.isLoading() && this.props.titleOnLoading) {
      return this.props.titleOnLoading;
    }
    else if (this.hasFailed() && this.props.titleOnFail) {
      return this.props.titleOnFail;
    }

    return this.props.title;
  }

  getDescription() {
    if (this.hasFailed()) {
      return this.props.errorMessage;
    }

    return this.props.description;
  }

  getCancelButtonText() {
    if (this.hasFailed()) {
      return 'Ok';
    }

    return this.props.cancelText || 'Cancelar';
  }

  onConfirm() {
    this.setState({actionTrigerred: true});

    this.props.submit(
      null, 
      {
        method: this.props.submitMethod,
        encType: "application/json"
      });
  }

  render() {
    if (this.hasFinished()) {
      return null;
    }

    return (
      <div key="action_window" className="action-window__pose-wrapper">

        <aside className={`action-window${this.props.className ? ` ${this.props.className}` : ''}`}>

          <div className="action-window__container">

            <div className="action-window__icon-wrapper">

              {this.getIcon()}

            </div>

            <h2 className={`action-window__title${this.isLoading() ? '--pulsing' : ''}`}>

              {this.getTitle()}

            </h2>

            {this.props.descriptionAsElement ? this.props.description : (
              <p className="action-window__description">

                {this.getDescription()}

              </p>
            )}

            {!this.isLoading() &&
              <div
                key="action_window:buttons"
                className="action-window__controls-wrapper"
              >

                <Link
                  className="action-window__cancel-button"
                  to={this.props.onCancelPath}
                >

                  {this.getCancelButtonText()}

                </Link>
                
                {this.props.errorMessage.length <= 0 &&
                  <button
                    className="action-window__confirm-button"
                    onClick={() => this.onConfirm()}
                  >

                    {this.props.confirmText || 'Confirmar'}

                  </button>
                }

              </div>
            }

          </div>

        </aside>

      </div>
    );
  }
}

const WrappedActionWindow = props => {
  const submit = useSubmit();
  const actionData = useActionData();
  const navigation = useNavigation();

  let errorMessage = '';

  if (actionData) {
    errorMessage = actionData.message || '';
  }  

  return (
    <ActionWindow
      submit={submit}
      errorMessage={errorMessage}
      navigation={navigation}
      {...props}
    />
  );
};

export { WrappedActionWindow as ActionWindow };
